/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as PagesActions from "../../actions/pagesActions";
import * as constants from "../../constants";

const deletePageLogic = createLogic({
	type: ActionTypes.DELETE_PAGE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader

		const { expId, page } = action;

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.delete(`/pages/${page}`)
					.then(() => {
						//TODO: dispatch action for stopping loader
						dispatch(PagesActions.deletePageSuccess(expId));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(PagesActions.deletePageFailure(error));
						done();
					});
			});
	},
});

export default [deletePageLogic];
